export enum ApiReturnCodes {
  Success = 1,
  OK = 200,
  BadRequest = 400,
  UnAuthorized = 401,
  AccessTokenNotProvided = -1051,
  Timeout = -1300,
  ErrorParams = -1301,
  ErrorTryCatch = -1303,
}

export enum RFMType {
  Recency = 1,
  Frequency = 2,
  Monetary = 3,
}

export enum RFMTier {
  VeryHigh = 1,
  High = 2,
  Medium = 3,
  Low = 4,
  VeryLow = 5,
  // Any = 6,
}

export const RFMTierDescriptions: Record<RFMTier, string> = {
  [RFMTier.VeryHigh]: "Very High",
  [RFMTier.High]: "High",
  [RFMTier.Medium]: "Medium",
  [RFMTier.Low]: "Low",
  [RFMTier.VeryLow]: "Very Low",
  // [RFMTier.Any]: "Any",
};

export enum DataState {
  NO_CHANGES = "NoChanges",
  CREATED = "Created",
  UPDATED = "Updated",
}

export enum RFMPeriod {
  Lifetime = 1,
  Last2Years = 2,
  Last1Year = 3,
  Last9Months = 4,
  Last6Months = 5,
  Last3Months = 6,
  CustomRange = 7,
}

// Campaign Channel
export enum ChannelEnum {
  Sms = 1,
  WhatsAppStandard = 2,
  WhatsAppPremium = 3,
  Email = 4,
}

// Campaign Type
export enum TypeEnum {
  Onetime = 1,
  Recurring_Weekly = 2,
  Recurring_Monthly = 3,
}

// Target Members Mode
export enum ModeEnum {
  Refresh = 1,
  Fixed = 2,
}

// Campaign Status
export enum StatusEnum {
  Draft = 0,
  Active = 1,
  Paused = 2,
  Completed = 3,
  Cancelled = 4,
  //stop
}

export enum CampaignTypeEnum {
  Voucher = 1,
  Point = 2,
  VoucherPoint = 3,
  EVoucher = 4,
  Custom = 5,
}
//Campaign Templates
export enum TemplatesTypeEnum {
  Default = 1,
  Custom = 2,
}

export enum EndScheduleEnum {
  // Never = 1,
  OnSpecificDate = 1,
  AfterOccurrences = 2,
}

export enum WeekDay {
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
  Sunday = 7,
}

